import { baseApi } from "common/redux/core/api.base";
import { ConfigurationHubService } from "../../services/configuration-hub.service";
import {
  CreateExtractionConfigurationRequest,
  UpdateExtractionConfigurationRequest
} from "../../models/configuration-hub.model";

const extractionConfigurationCommands = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createExtractionConfiguration: build.mutation<
      any,
      CreateExtractionConfigurationRequest
    >({
      queryFn: (configuration: CreateExtractionConfigurationRequest) => {
        return ConfigurationHubService.createExtractionConfiguration(
          configuration
        );
      },
      invalidatesTags: ["EXTRACTION_CONFIGURATIONS"]
    }),

    updateExtractionConfiguration: build.mutation<
      any,
      UpdateExtractionConfigurationRequest
    >({
      queryFn: (updateRequest: UpdateExtractionConfigurationRequest) => {
        return ConfigurationHubService.updateExtractionConfiguration(
          updateRequest
        );
      },
      invalidatesTags: ["EXTRACTION_CONFIGURATIONS"]
    }),

    deleteExtractionConfiguration: build.mutation<void, number>({
      queryFn: async (configurationId: number) => {
        const response =
          await ConfigurationHubService.deleteExtractionConfiguration(
            configurationId
          );
        return { data: undefined };
      },
      invalidatesTags: ["EXTRACTION_CONFIGURATIONS"]
    })
  })
});

export const {
  useCreateExtractionConfigurationMutation,
  useUpdateExtractionConfigurationMutation,
  useDeleteExtractionConfigurationMutation
} = extractionConfigurationCommands;
